var DevOps = "DevOps";
var Gaming = "الألعاب";
var Migration = "الترحيل";
var Other = "أخرى";
var useCase = {
	"Use case": "حالة الاستخدام",
	"AI & machine learning": "الذكاء الاصطناعي وتعلم الآلة",
	"Batch processing": "معالجة الحزم",
	"Big data, analytics, & business intelligence": "البيانات الكبيرة والتحليلات والمعلومات التجارية",
	"Business applications - Microsoft": "تطبيقات الأعمال - Microsoft",
	"Business applications - Oracle": "تطبيقات الأعمال - Oracle",
	"Business applications - Other": "تطبيقات الأعمال - أخرى",
	"Business applications - SAP": "تطبيقات الأعمال - SAP",
	"Content delivery": "توصيل المحتوى",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "إنترنت الأشياء",
	"Learning & certification": "التعلم والشهادات",
	"Media services": "خدمات الوسائط",
	Migration: Migration,
	"Mobile applications": "تطبيقات الأجهزة المحمولة",
	Other: Other,
	"Storage & backup": "التخزين والنسخ الاحتياطي",
	"Websites & web apps": "مواقع الويب وتطبيقات الويب"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
